import { TextField as MUITextField } from "@mui/material";

const TextField = (props) => {
  return <MUITextField {...props} />;
};

export default TextField;
